import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/setting/order-by-options/`;

const getOrderByOptions = async () => {
  return await axios.get(API_URL);
};

/** Get active options only (for OrderForm dropdown) */
const getActiveOrderByOptions = async () => {
  return await axios.get(API_URL + 'list');
};

const getOrderByOption = async (id) => {
  return await axios.get(API_URL + id);
};

/** Daily JPY usage for routing window (Thai 02:00 service day), same logic as order routing caps */
const getDailyUsageForOption = async (id) => {
  return await axios.get(`${API_URL}${id}/daily-usage`);
};

const addOrderByOption = async (data) => {
  return await axios.post(API_URL, data);
};

const editOrderByOption = async (id, data) => {
  return await axios.put(API_URL + id, data);
};

const deleteOrderByOption = async (id) => {
  return await axios.delete(API_URL + id);
};

const toggleSuspend = async (id, enable) => {
  return await axios.post(`${API_URL}${id}/toggle-suspend`, { enable });
};

/** Manually run the tracking-sheet sync now instead of waiting for the hourly cron */
const runTrackingSyncNow = async () => {
  return await axios.post(API_URL + 'sync-tracking-now');
};

export default {
  getOrderByOptions,
  getActiveOrderByOptions,
  getOrderByOption,
  getDailyUsageForOption,
  addOrderByOption,
  editOrderByOption,
  deleteOrderByOption,
  toggleSuspend,
  runTrackingSyncNow,
};
